//import React, { useState, useEffect } from "react";
//import { IoIosAddCircleOutline } from "react-icons/io";
//import Loading from "../../component/Loading/Loading";
//import { useSelector } from "react-redux";
//import AlertMsg from '../../component/AlertMsg/AlertMsg';
//import { AiOutlineSortAscending } from "react-icons/ai";
//import Pagination from "../../utils/Pagenation/Pagenation";
//import useAxiosInstance from "../../services/useAxiosInstance";
//import { Plus, Pencil, Trash2, Search } from "lucide-react";
//import GlassmorphicModal from "../../component/ReusableComponents/GlassmorphicModal";

//const AddAmenityType = () => {
//  const axiosInstance = useAxiosInstance();
//  const communityId = useSelector((state) => state.auth.communityId);
//  const [amenityTypes, setAmenityTypes] = useState([]);
//  const [isLoading, setIsLoading] = useState(true);
//  const [selectedAmenityType, setSelectedAmenityType] = useState(null);
//  const [showDeleteModal, setShowDeleteModal] = useState(false);
//  const [showAddModal, setShowAddModal] = useState(false);
//  const [showEditModal, setShowEditModal] = useState(false);
//  const [editedAmenityTypeName, setEditedAmenityTypeName] = useState("");
//  const [newAmenityTypeName, setNewAmenityTypeName] = useState("");
//  const [editError, setEditError] = useState("");
//  const [addError, setAddError] = useState("");
//  const token = useSelector((state) => state.auth.token);

//  const [alert, setAlert] = useState({ visible: false, message: '', type: '' });

//  const fetchData = async () => {
//    setIsLoading(true);
//    try {
//      const response = await axiosInstance.get(`/api/public/amenitytype/findByCommunityId/${communityId}`
//      );

//      setAmenityTypes(response.data);
//    } catch (error) {
//      console.error("Error fetching amenity types:", error.response ? error.response.data : error.message);

//      if (error.response && error.response.status === 401) {
//        console.log('Unauthorized access, redirecting to login...');
//      }
//    } finally {
//      setIsLoading(false);
//    }
//  };

//  useEffect(() => {
//    fetchData();
//  }, [communityId]);

//  const handleView = (amenityType) => {
//    setSelectedAmenityType(amenityType);
//  };

//  const handleEdit = (amenityType) => {
//    setSelectedAmenityType(amenityType);
//    setEditedAmenityTypeName(amenityType.name);
//    setShowEditModal(true);
//  };

//  const confirmDelete = (id) => {
//    console.log(`Deleting amenity type with ID: ${id}`);
//    setIsLoading(true);
//    setShowDeleteModal(false);

//    axiosInstance.delete(`/api/public/amenitytype/delete/${id}`)
//      .then(response => {
//        console.log("Amenity type deleted successfully:", response);
//        setAlert({ visible: true, message: 'Amenity type deleted successfully!', type: 'success' });
//        fetchData();
//      })
//      .catch(error => {
//        console.error("Error deleting amenity type:", error);
//        setAlert({ visible: true, message: 'Error deleting amenity type: Please try again.', type: 'error' });
//      })
//      .finally(() => {
//        setIsLoading(false);
//      });
//  };

//  const closeModal = () => {
//    setSelectedAmenityType(null);
//    setShowDeleteModal(false);
//    setShowAddModal(false);
//    setShowEditModal(false);
//    setEditedAmenityTypeName("");
//    setNewAmenityTypeName("");
//    setEditError("");
//    setAddError("");
//  };

//  const handleAddAmenityType = () => {
//    setShowAddModal(true);
//  };

//  const validateAmenityTypeName = (name) => {
//    if (!name) {
//      return "Amenity Type Name is required.";
//    }
//    return "";
//  };

//  const handleEditAmenityType = () => {
//    const error = validateAmenityTypeName(editedAmenityTypeName);
//    if (error) {
//      setEditError(error);
//      return;
//    }
//    const updatedAmenityTypeData = {
//      id: selectedAmenityType.id,
//      name: editedAmenityTypeName,
//      activeStatus: true,
//      communityId: communityId,
//    };
//    setShowEditModal(false);
//    setIsLoading(true);

//    axiosInstance
//      .put(`/api/public/amenitytype/update/${selectedAmenityType.id}`, updatedAmenityTypeData)
//      .then((response) => {
//        setAlert({ visible: true, message: 'Amenity type updated successfully!', type: 'success' });
//        fetchData();
//        setIsLoading(false);
//      })
//      .catch((error) => {
//        console.error("Error updating amenity type:", error);
//        setAlert({ visible: true, message: 'Error updating amenity type: Please try again.', type: 'error' });
//        setIsLoading(false);
//      });
//  };

//  const handleAddNewAmenityType = () => {
//    const error = validateAmenityTypeName(newAmenityTypeName);
//    if (error) {
//      setAddError(error);
//      return;
//    }
//    const newAmenityTypeData = {
//      activeStatus: true,
//      communityId: communityId,
//      name: newAmenityTypeName,
//    };
//    setShowAddModal(false);
//    setIsLoading(true);
//    axiosInstance
//      .post(`/api/public/amenitytype/add`, newAmenityTypeData)
//      .then((response) => {
//        console.log("Amenity type added successfully:", response.data);
//        setAlert({ visible: true, message: 'Amenity type added successfully!', type: 'success' });
//        fetchData();
//        setIsLoading(false);
//      })
//      .catch((error) => {
//        console.error("Error adding new amenity type:", error);
//        setAlert({ visible: true, message: 'Error adding new amenity type: Please try again.', type: 'error' });
//        setIsLoading(false);
//      });
//  };

//  const [sortOrder, setSortOrder] = useState('none');
//  const [currentPage, setCurrentPage] = useState(0);
//  const itemsPerPage = 5;

//  const handleSort = () => {
//    setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
//  };

//  const sortedAmenity = [...amenityTypes].sort((a, b) => {
//    if (sortOrder === 'asc') {
//      return a.name.localeCompare(b.name);
//    } else if (sortOrder === 'desc') {
//      return b.name.localeCompare(a.name);
//    }
//    return 0;
//  });

//  const pageCount = Math.ceil(sortedAmenity.length / itemsPerPage);
//  const currentAmenityTypes = sortedAmenity.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

//  // Edit modal footer with action buttons
//  const editModalFooter = (
//    <div className="flex justify-end space-x-2">
//      <button
//        type="button"
//        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
//        onClick={closeModal}
//      >
//        Cancel
//      </button>
//      <button
//        type="button"
//        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
//        onClick={handleEditAmenityType}
//      >
//        Save Changes
//      </button>
//    </div>
//  );

//  // Add modal footer with action buttons
//  const addModalFooter = (
//    <div className="flex justify-end space-x-2">
//      <button
//        type="button"
//        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
//        onClick={closeModal}
//      >
//        Cancel
//      </button>
//      <button
//        type="button"
//        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
//        onClick={handleAddNewAmenityType}
//      >
//        Add
//      </button>
//    </div>
//  );

//  // Delete modal footer with action buttons
//  const deleteModalFooter = (
//    <div className="flex justify-end space-x-2">
//      <button
//        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
//        onClick={closeModal}
//      >
//        Cancel
//      </button>
//      <button
//        className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
//        onClick={() => confirmDelete(selectedAmenityType.id)}
//      >
//        Delete
//      </button>
//    </div>
//  );

//  return (
//    <div className="bg-gray-50 min-h-screen md:p-4">
//      {isLoading && <Loading />}
//      {!isLoading && (
//        <div className="max-w-7xl mx-auto">
//          {alert.visible && (
//            <AlertMsg
//              message={alert.message}
//              type={alert.type}
//              onClose={() => setAlert({ ...alert, visible: false })}
//            />
//          )}
//          <div className="flex justify-between items-center mb-6">
//            <h1 className="text-2xl font-bold text-gray-800">Amenity Types</h1>
//            <div className="flex items-center">
//              <button
//                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2"
//                onClick={handleAddAmenityType}
//              >
//                <Plus size={18} />
//                <span>Add</span>
//              </button>
//            </div>
//          </div>

//          <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
//            <div className="overflow-x-auto">
//              <table className="min-w-full divide-y divide-gray-200">
//                <thead className="bg-blue-400">
//                  <tr>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">
//                      Name  <button
//                        onClick={handleSort}
//                      >
//                        <AiOutlineSortAscending className="inline ml-1" />
//                      </button>
//                    </th>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">
//                      Action
//                    </th>
//                  </tr>
//                </thead>
//                <tbody className="bg-white divide-y divide-gray-200">
//                  {currentAmenityTypes.length === 0 ? (
//                    <tr>
//                      <td colSpan="2" className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
//                    </tr>
//                  ) : (
//                    currentAmenityTypes.map((amenityType) => (
//                      <tr key={amenityType.id} className="hover:bg-gray-50">
//                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{amenityType.name}</td>
//                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium flex gap-3">
//                          <button
//                            className="text-gray-500 hover:text-gray-700"
//                            onClick={() => handleEdit(amenityType)}
//                            title="Edit Type"
//                          >
//                            <Pencil size={18} />
//                          </button>
//                          <button
//                            className="text-red-500 hover:text-red-700"
//                            onClick={() => {
//                              setSelectedAmenityType(amenityType);
//                              setShowDeleteModal(true);
//                            }}
//                            title="Delete Type"
//                          >
//                            <Trash2 size={18} />
//                          </button>
//                        </td>
//                      </tr>
//                    ))
//                  )}
//                </tbody>
//              </table>
//            </div>

//            <div className="bg-gray-50 px-6 py-3 flex items-center justify-between border-t border-gray-200">
//              <div className="text-sm text-gray-700">
//                Page {currentPage + 1} of {pageCount}
//              </div>
//              <div className="flex-1 flex justify-end">
//                <Pagination
//                  currentPage={currentPage}
//                  pageCount={pageCount}
//                  setCurrentPage={setCurrentPage}
//                />
//              </div>
//            </div>
//          </div>
//        </div>
//      )}

//      {/* Edit Modal using GlassmorphicModal */}
//      <GlassmorphicModal
//        isOpen={showEditModal}
//        onClose={closeModal}
//        title="Edit Amenity Type"
//        size="md"
//        footer={editModalFooter}
//      >
//        <div className="space-y-4">
//          <div>
//            <label className="block text-sm font-medium text-gray-700 mb-1">
//              Amenity Type Name <span className="text-red-500">*</span>
//            </label>
//            <input
//              type="text"
//              placeholder="Enter Amenity Type Name"
//              value={editedAmenityTypeName}
//              onChange={(e) => {
//                setEditedAmenityTypeName(e.target.value);
//                setEditError("");
//              }}
//              className={`w-full rounded-md border ${editError ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
//            />
//            {editError && <p className="text-red-500 text-sm mt-1">{editError}</p>}
//          </div>
//          <div className="text-sm text-red-500">* indicates required field</div>
//        </div>
//      </GlassmorphicModal>

//      {/* Delete Modal using GlassmorphicModal */}
//      <GlassmorphicModal
//        isOpen={showDeleteModal}
//        onClose={closeModal}
//        title="Confirm Delete"
//        size="sm"
//        footer={deleteModalFooter}
//      >
//        <p className="text-gray-700">
//          Are you sure you want to delete this amenity type? This action cannot be undone.
//        </p>
//      </GlassmorphicModal>

//      {/* Add Modal using GlassmorphicModal */}
//      <GlassmorphicModal
//        isOpen={showAddModal}
//        onClose={closeModal}
//        title="Add New Amenity Type"
//        size="md"
//        footer={addModalFooter}
//      >
//        <div className="space-y-4">
//          <div>
//            <label className="block text-sm font-medium text-gray-700 mb-1">
//              Amenity Type Name <span className="text-red-500">*</span>
//            </label>
//            <input
//              type="text"
//              placeholder="Enter Amenity Type Name"
//              value={newAmenityTypeName}
//              onChange={(e) => {
//                setNewAmenityTypeName(e.target.value);
//                setAddError("");
//              }}
//              className={`w-full rounded-md border ${addError ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
//            />
//            {addError && <p className="text-red-500 text-sm mt-1">{addError}</p>}
//          </div>
//          <div className="text-sm text-red-500">* indicates required field</div>
//        </div>
//      </GlassmorphicModal>
//    </div>
//  );
//};

//export default AddAmenityType;

import React, { useState, useEffect } from "react";
import { IoIosAddCircleOutline } from "react-icons/io";
import Loading from "../../component/Loading/Loading";
import { useSelector } from "react-redux";
import AlertMsg from '../../component/AlertMsg/AlertMsg';
import { AiOutlineSortAscending } from "react-icons/ai";
import Pagination from "../../utils/Pagenation/Pagenation";
import useAxiosInstance from "../../services/useAxiosInstance";
import { Plus, Pencil, Trash2, Search } from "lucide-react";
import GlassmorphicModal from "../../component/ReusableComponents/GlassmorphicModal";

const AddAmenityType = () => {
    const axiosInstance = useAxiosInstance();
    const communityId = useSelector((state) => state.auth.communityId);
    const [amenityTypes, setAmenityTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedAmenityType, setSelectedAmenityType] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editedAmenityTypeName, setEditedAmenityTypeName] = useState("");
    const [newAmenityTypeName, setNewAmenityTypeName] = useState("");
    const [editError, setEditError] = useState("");
    const [addError, setAddError] = useState("");
    const token = useSelector((state) => state.auth.token);
    const [activeStatus, setActiveStatus] = useState(true);

    const [alert, setAlert] = useState({ visible: false, message: '', type: '' });

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.get(`/api/public/amenitytype/findByCommunityId/${communityId}`
            );

            setAmenityTypes(response.data);
        } catch (error) {
            console.error("Error fetching amenity types:", error.response ? error.response.data : error.message);

            if (error.response && error.response.status === 401) {
                console.log('Unauthorized access, redirecting to login...');
            }
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [communityId,]);

    const handleView = (amenityType) => {
        setSelectedAmenityType(amenityType);
    };

    const handleEdit = (amenityType) => {
        setSelectedAmenityType(amenityType);
        setEditedAmenityTypeName(amenityType.name);
        setShowEditModal(true);
    };

    const confirmDelete = (id) => {
        console.log(`Deleting amenity type with ID: ${id}`);
        setIsLoading(true);
        setShowDeleteModal(false);

        axiosInstance.delete(`/api/public/amenitytype/delete/${id}`)
            .then(response => {
                console.log("Amenity type deleted successfully:", response);
                setAlert({ visible: true, message: 'Amenity type deleted successfully!', type: 'success' });
                fetchData();
            })
            .catch(error => {
                console.error("Error deleting amenity type:", error);
                setAlert({ visible: true, message: 'Error deleting amenity type: Please try again.', type: 'error' });
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const closeModal = () => {
        setSelectedAmenityType(null);
        setShowDeleteModal(false);
        setShowAddModal(false);
        setShowEditModal(false);
        setEditedAmenityTypeName("");
        setNewAmenityTypeName("");
        setEditError("");
        setAddError("");
    };

    const handleAddAmenityType = () => {
        setShowAddModal(true);
    };

    const validateAmenityTypeName = (name) => {
        if (!name) {
            return "Amenity Type Name is required.";
        }
        return "";
    };

    const handleEditAmenityType = () => {
        const error = validateAmenityTypeName(editedAmenityTypeName);
        if (error) {
            setEditError(error);
            return;
        }
        const updatedAmenityTypeData = {
            id: selectedAmenityType.id,
            name: editedAmenityTypeName,
            activeStatus: activeStatus,
            communityId: communityId,
        };
        setShowEditModal(false);
        setIsLoading(true);

        axiosInstance
            .put(`/api/public/amenitytype/update/${selectedAmenityType.id}`, updatedAmenityTypeData)
            .then((response) => {
                setAlert({ visible: true, message: 'Amenity type updated successfully!', type: 'success' });
                fetchData();
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error updating amenity type:", error);
                setAlert({ visible: true, message: 'Error updating amenity type: Please try again.', type: 'error' });
                setIsLoading(false);
            });
    };

    const handleAddNewAmenityType = () => {
        const error = validateAmenityTypeName(newAmenityTypeName);
        if (error) {
            setAddError(error);
            return;
        }
        const newAmenityTypeData = {
            activeStatus: true,
            communityId: communityId,
            name: newAmenityTypeName,
        };
        setShowAddModal(false);
        setIsLoading(true);
        axiosInstance
            .post(`/api/public/amenitytype/add`, newAmenityTypeData)
            .then((response) => {
                console.log("Amenity type added successfully:", response.data);
                setAlert({ visible: true, message: 'Amenity type added successfully!', type: 'success' });
                fetchData();
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error adding new amenity type:", error);
                setAlert({ visible: true, message: 'Error adding new amenity type: Please try again.', type: 'error' });
                setIsLoading(false);
            });
    };

    const [sortOrder, setSortOrder] = useState('none');
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 5;

    const handleSort = () => {
        setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

    const sortedAmenity = [...amenityTypes].sort((a, b) => {
        if (sortOrder === 'asc') {
            return a.name.localeCompare(b.name);
        } else if (sortOrder === 'desc') {
            return b.name.localeCompare(a.name);
        }
        return 0;
    });

    const pageCount = Math.ceil(sortedAmenity.length / itemsPerPage);
    const currentAmenityTypes = sortedAmenity.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    // Edit modal footer with action buttons
    const editModalFooter = (
        <div className="flex justify-end space-x-2">
            <button
                type="button"
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
                onClick={closeModal}
            >
                Cancel
            </button>
            <button
                type="button"
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                onClick={handleEditAmenityType}
            >
                Save Changes
            </button>
        </div>
    );

    // Add modal footer with action buttons
    const addModalFooter = (
        <div className="flex justify-end space-x-2">
            <button
                type="button"
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
                onClick={closeModal}
            >
                Cancel
            </button>
            <button
                type="button"
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                onClick={handleAddNewAmenityType}
            >
                Add
            </button>
        </div>
    );

    // Delete modal footer with action buttons
    const deleteModalFooter = (
        <div className="flex justify-end space-x-2">
            <button
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
                onClick={closeModal}
            >
                Cancel
            </button>
            <button
                className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
                onClick={() => confirmDelete(selectedAmenityType.id)}
            >
                Delete
            </button>
        </div>
    );

    return (
        <div className="bg-gray-50 min-h-screen md:p-4">
            {isLoading && <Loading />}
            {!isLoading && (
                <div className="max-w-7xl mx-auto">
                    {alert.visible && (
                        <AlertMsg
                            message={alert.message}
                            type={alert.type}
                            onClose={() => setAlert({ ...alert, visible: false })}
                        />
                    )}
                    <div className="flex justify-between items-center mb-6">
                        <h1 className="text-2xl font-bold text-gray-800">Amenity Types</h1>
                        <div className="flex items-center">
                            <button
                                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2"
                                onClick={handleAddAmenityType}
                            >
                                <Plus size={18} />
                                <span>Add</span>
                            </button>
                        </div>
                    </div>

                    <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-blue-400">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">
                                            Name  <button
                                                onClick={handleSort}
                                            >
                                                <AiOutlineSortAscending className="inline ml-1" />
                                            </button>
                                        </th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">
                                            Active Status
                                        </th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {currentAmenityTypes.length === 0 ? (
                                        <tr>
                                            <td colSpan="3" className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
                                        </tr>
                                    ) : (
                                        currentAmenityTypes.map((amenityType) => (
                                            <tr key={amenityType.id} className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{amenityType.name}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-left">
                                                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${amenityType.activeStatus
                                                            ? 'text-green-800 bg-green-100'
                                                            : 'text-red-800 bg-red-100'
                                                        }`}>
                                                        {amenityType.activeStatus ? "Active" : "Inactive"}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium flex gap-3">
                                                    <button
                                                        className="text-gray-500 hover:text-gray-700"
                                                        onClick={() => handleEdit(amenityType)}
                                                        title="Edit Type"
                                                    >
                                                        <Pencil size={18} />
                                                    </button>
                                                    {/* <button
                                                        className="text-red-500 hover:text-red-700"
                                                        onClick={() => {
                                                            setSelectedAmenityType(amenityType);
                                                            setShowDeleteModal(true);
                                                        }}
                                                        title="Delete Type"
                                                    >
                                                        <Trash2 size={18} />
                                                    </button> */}
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="bg-gray-50 px-6 py-3 flex items-center justify-between border-t border-gray-200">
                            <div className="text-sm text-gray-700">
                                Page {currentPage + 1} of {pageCount}
                            </div>
                            <div className="flex-1 flex justify-end">
                                <Pagination
                                    currentPage={currentPage}
                                    pageCount={pageCount}
                                    setCurrentPage={setCurrentPage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Modal using GlassmorphicModal */}
            <GlassmorphicModal
                isOpen={showEditModal}
                onClose={closeModal}
                title="Edit Amenity Type"
                size="md"
                footer={editModalFooter}
            >
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Amenity Type Name <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            placeholder="Enter Amenity Type Name"
                            maxLength={100}
                            value={editedAmenityTypeName}
                            onChange={(e) => {
                                setEditedAmenityTypeName(e.target.value);
                                setEditError("");
                            }}
                            className={`w-full rounded-md border ${editError ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        />
                        {editError && <p className="text-red-500 text-sm mt-1">{editError}</p>}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-3">Active Status:</label>
                        <div className="flex space-x-6">
                            <label className="flex items-center">
                                <input
                                    type="radio"
                                    name="activeStatus"
                                    checked={activeStatus}
                                    onChange={() => setActiveStatus(true)}
                                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                                />
                                <span className="ml-2 text-sm text-gray-700">Active</span>
                            </label>
                            <label className="flex items-center">
                                <input
                                    type="radio"
                                    name="activeStatus"
                                    checked={!activeStatus}
                                    onChange={() => setActiveStatus(false)}
                                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                                />
                                <span className="ml-2 text-sm text-gray-700">Inactive</span>
                            </label>
                        </div>
                    </div>

                    <div className="text-sm text-red-500">* indicates required field</div>
                </div>
            </GlassmorphicModal>

            {/* Delete Modal using GlassmorphicModal */}
            <GlassmorphicModal
                isOpen={showDeleteModal}
                onClose={closeModal}
                title="Confirm Delete"
                size="sm"
                footer={deleteModalFooter}
            >
                <p className="text-gray-700">
                    Are you sure you want to delete this amenity type? This action cannot be undone.
                </p>
            </GlassmorphicModal>

            {/* Add Modal using GlassmorphicModal */}
            <GlassmorphicModal
                isOpen={showAddModal}
                onClose={closeModal}
                title="Add New Amenity Type"
                size="md"
                footer={addModalFooter}
            >
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Amenity Type Name <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            placeholder="Enter Amenity Type Name"
                            value={newAmenityTypeName}
                            maxLength={100}
                            onChange={(e) => {
                                setNewAmenityTypeName(e.target.value);
                                setAddError("");
                            }}
                            className={`w-full rounded-md border ${addError ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        />
                        {addError && <p className="text-red-500 text-sm mt-1">{addError}</p>}
                    </div>
                    <div className="text-sm text-red-500">* indicates required field</div>
                </div>
            </GlassmorphicModal>
        </div>
    );
};

export default AddAmenityType;